import React, { useEffect, useState } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import useOnScroll from 'jd-library/useOnScroll';
import { useDispatch, useSelector} from 'react-redux';
import {addJdCatCoverData} from '../../actions/jdCategoryCover';
import historyHandler from 'jd-library/historyHandler';
import "./jd-category-cover.scss";
import toastMessageActions from 'jd-library/toastMessageActions';
import Dropdown from 'jd-library/Dropdown';
import { productCatCapitalize } from '../../utills';

const SingleCategoryCover = (props) => {

    let optionsList = [];
    let list = [
        { lebal: "Irrelevant Category for Seller", value: "Irrelevant Category for Seller" },
        { lebal: "To be Launched Soon", value: "To be Launched Soon" },
        { lebal: "Generalized Category", value: "Generalized Category" },
    ]
    optionsList = optionsList.concat(
        list.map((value, index) => {
            return {
            label: value.lebal,
            key: value.value,
            };
        })
    );

    return(
        <>
            <div className="single-cat-cover-list">
                <div className="single-cat-cover-holder">
                    <div className="single-cat-cover-left">
                        <div className="left-cover-name">
                            JD Mart Cat Name
                        </div>
                        <div className="left-cover-cat">
                            {productCatCapitalize(props.item.name) || ''}
                        </div>
                    </div>
                    <div className="single-cat-cover-right">
                        <div className="left-cover-name">
                            {`${props.item.isProductService == 'service' ? 'Service' : 'Product'} Count`}
                        </div>
                        <div className="left-cover-cat text-right">
                            {props.item.cnt || 0}
                        </div>
                        {!props.isCoverd ?
                            <div className="left-cover-link">
                                <span className="left-cover-icon icon-plus reducesize"></span>
                                <span className="left-cover-icon" onClick={()=> props.redirectToAddProduct(`${props.item.isProductService == 'service' ? 'service' : 'product'}`)}>{`Add ${props.item.isProductService == 'product' ? 'Product' : 'Service'}`}</span>
                            </div>
                            : null
                        }    
                    </div>
                </div>
                {!props.isCoverd ? 
                    <div className="single-cat-cover-drop">
                        <Dropdown
                            placeholder={'Select Remark'}
                            label={'Remark'}
                            optionList={optionsList}
                            onChange={(e)=> props.handleRemarkChange(props.index,e.key)}
                            value={props.remark}
                            errorMessage={props.error[props.index]}
                            error={props.error[props.index]}
                            placeholderClass={''}
                        ></Dropdown>
                    </div>
                    :null
                }
            </div>
        </>    
    )
}

const JdCategoryCover = (props) => {
    const [scrolled, setScroll] = useState(false);
    const [showCatCoverList, toggleShowCatCoverList] = useState(false);
    const [remark, setRemark] = useState({});
    const [error, setError] = useState({});
    const [scrollEl, setScrollEl] = useState(null);
    
    const dispatch = useDispatch();

    const categoryCoverList = useSelector((state)=> state.jdCategoryList.listing)
    const supplierId = useSelector((state)=> state.session.supplierId)
    const docId = useSelector((state)=> state.session.docId)

    const [nonCoveredCat, setNonCoveredCat] = useState(categoryCoverList.nonExistingJdId || []);
    

    useOnScroll({
        callback : (e,scrollObj) => {
          if(scrollObj.currScroll.scrollTop){
            setScroll(true);
          }else{
             setScroll(false)
          }
        },
        element : !scrollEl ? null : scrollEl,
        deps: [scrollEl]
    })

    const validateData = () =>{
		let isError= false, errObj={};
        nonCoveredCat.map((cur, index)=>{
            if(!cur.remark){
                errObj[index] = 'Please Select Remark';
                isError= true;
            }
        })
        setError({...errObj});
        return isError;
    }

    const handleRemarkChange = (index, val) =>{
		let errObj={...error};
        errObj[index] = ''
        setError({...errObj});
        const nonCoveredCatList = [...nonCoveredCat];
        let singleList = nonCoveredCatList[index];
		singleList.remark = val;
        nonCoveredCatList[index] = {...singleList};
		// setRemark(remarkList);
        setNonCoveredCat(nonCoveredCatList);
    }

    const handleShowSection = () =>{
        if(categoryCoverList.existingJdId.length){
            toggleShowCatCoverList(!showCatCoverList);
        }
    }

    const onBtnClick = () =>{
        let saveData = {};
        let validate = validateData();
        if(validate){
            return;
        }
        saveData.supplierId = supplierId;
        saveData.docId = docId;
        saveData.request = {};
        nonCoveredCat.map((cur,index)=>{
            saveData.request[cur.jdmartid] = cur.remark;
        })
        // let dataObj = JSON.stringify(saveData);
        saveData.request = JSON.stringify(saveData.request);
        
        addJdCatCoverData(saveData, {
            cb: (data) =>{
                if(!data.isError){
                    historyHandler.closeCurrent()
                }
            }
        })
    }
    const jDCatStatusHeaderPercent = () => {
        let numerator = categoryCoverList?.existingJdId.length;
        let denominator = categoryCoverList?.existingJdId.length + categoryCoverList?.nonExistingJdId.length;
        if (denominator !== 0){
            return `${((numerator / denominator)*100).toFixed(2)}% (${numerator} out of ${denominator} covered)`
        }else {
            return ''
        }
    }

    const isFromGenioLite = !!props.session.user?.loggedUser?.fromGenioLite || getCookie('fromGenioLite') == '1';;
    const btnArr = isFromGenioLite ? [
        {
            children: 'Skip & Continue',
            clickHandler: () => {
                historyHandler.closeCurrent()
            },
            size: "lg",
            className: 'category-cover-footer-btn'
        }
    ] : [{
        children: 'Save & Continue',
        clickHandler: () => {
            onBtnClick();
        },
        size: "lg",
        className: 'category-cover-footer-btn'
    }];

    return (
        <>
            <SliderWrapper
                header={{
                    heading: 'JD Mart Category Covered Status',
                    subHeading: jDCatStatusHeaderPercent(),
                    variant: 'secondary',
                    className: 'category-cover-slider-header',
                    leftIcons: [],
                    rightIcons: [],
                }}
                footer={{
                    btnProps: btnArr
                }}
                onHidden={ 
                    props.onHidden
                }
                slider={{
                    className: 'category-cover-animate-slider'
                }}
                updateScrollContRef={(scrollref) => {
                    setScrollEl(scrollref)
                }}
            >
                <div className="category-cover-container">
                    <div className="category-not-cover-holder">
                        <div className="category-not-cover-title">
                            JD Mart Category Not Covered
                        </div>
                        {nonCoveredCat.map((cur,index)=>{
                            return(
                                <SingleCategoryCover
                                    index={index}
                                    remark = {cur.remark || ''}
                                    handleRemarkChange={handleRemarkChange}
                                    redirectToAddProduct = {props.redirectToAddProduct}
                                    error={error}
                                    item= {cur}
                                />  
                            )
                        })}
                    </div>
                    <div className="category-not-cover-holder">
                        <div className="category-not-cover-title pointer" onClick={handleShowSection}>
                            <span>JD Mart Category Covered</span>
                            {categoryCoverList.existingJdId.length ? 
                                <span className={` cat-icon-cover ${showCatCoverList ? 'icon-pagination-up' : 'icon-pagination-down'}`}></span>
                                : null
                            }
                        </div>
                        {showCatCoverList ? 
                            categoryCoverList.existingJdId.map((cur,index)=>{
                                return(
                                    <SingleCategoryCover
                                        remark = {remark}
                                        handleRemarkChange={handleRemarkChange}
                                        isCoverd={true}
                                        item= {cur}
                                        index= {index}
                                    />
                                )
                            })
                            : null  
                        }
                    </div>
                </div>
            </SliderWrapper>
        </>
    )
};

export default JdCategoryCover;